/**
 * Copyright (C) 2019 User X, LLC http://whoisuserx.com <info@userx.co>
 *
 * This program is the intellectual property of User X, LLC. You may
 * not redistribute and/or modify it without written consent by controlling
 * entities of User X, LLC.
 *
 * You should have received a copy of our Web Developer Agreement which
 * outlines proper use and distribution of this program. If you did not
 * please email info@userx.co to request your copy.
 */
import AdminMessaging from "./_ui/AdminMessaging";
import AdminCompanies from "./_ui/AdminCompanies";
import AdminAgents from "./_ui/AdminAgents";
import {useNavigate, useParams} from "react-router";

/**
 * File created by John M. Woodcock < john@userx.co >
 * on 8/2/2025
 * for userx-support
 */
const CRM = ({}) => {
    const navigate = useNavigate();
    const params = useParams();
    const activeSection = params.section || 'direct';
    const sections = [
        {id:'direct', name:'Direct Messaging', classes:''},
        {id:'flows', name:'Flows', classes:''},
        {id:'campaigns', name:'Campaigns', classes:''}
    ]

    return (
        <div className=" d-flex flex-column h-100">
            <h3>Client Relations Manager</h3>
            <p>Manage communications with clients with messaging, automated campaigns, and more .</p>
            <div className={`component-container flex-grow-1 d-flex overflow-auto`}>
            {/* put tabs here */}
            <div className="nav flex-column nav-pills me-4" role="tablist" aria-orientation="vertical">
                {sections.map((section, index) => (
                    <button
                        key={section.id}
                        className={`nav-link ${index === 0 ? 'active' : ''} ${section.classes}`}
                        id={`v-${section.id}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#v-${section.id}`}
                        type="button"
                        role="tab"
                        aria-controls={`v-${section.id}`}
                        aria-selected={index === 0}
                        onClick={() => navigate(`/admins/settings/crm/${section.id}`)}
                    >
                        {section.name}
                    </button>
                ))}
            </div>
            <div className="tab-content flex-grow-1" style={{minHeight: '300px'}}>
                {sections.map((section, index) => (
                    <div
                        key={section.id}
                        className={`tab-pane fade ${activeSection === section.id ? 'show active' : ''}`}
                        id={`v-${section.id}`}
                        role="tabpanel"
                        aria-labelledby={`v-${section.id}-tab`}
                    >
                        {section.id === 'direct' && <AdminMessaging />}
                        {section.id === 'flows' && <p>Flows module coming soon.</p>}
                        {section.id === 'campaigns' && <p>Campaigns module coming soon.</p>}
                    </div>
                ))}
            </div>
        </div>
        </div>
    );
};

export default CRM;